var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSapIcon = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 45,
    viewBox: "0 0 53 45",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_305_19692)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 45H26.7853L53 0H0V45Z",
    fill: "url(#paint0_linear_305_19692)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4532 8.46171H26.2352V29.7529L21.6778 8.45509H17.159L13.2686 26.261C12.8522 21.772 10.1532 20.2213 8.01975 19.0588C6.61372 18.2845 5.12158 17.1441 5.14086 15.8823C5.15242 14.8499 5.94155 13.897 7.5031 14.0338C8.55312 14.1286 9.47848 14.2742 11.3215 15.7985L13.1337 10.383C11.4462 8.91612 9.12505 7.98744 7.21906 7.98303H7.20749C4.98663 7.98303 3.13591 9.21833 1.98949 11.2544C1.19563 12.6531 0.748354 14.5253 0.74154 16.4779C0.71198 19.2242 1.29933 21.1764 2.53314 22.7205C3.57417 24.0308 4.90566 24.8801 6.08035 25.5044C7.5288 26.2742 8.7112 26.9448 8.69707 28.372C8.6889 28.8981 8.56652 29.4001 8.35391 29.7794C7.99276 30.4191 7.43755 30.6617 6.67156 30.6838C5.19484 30.7367 4.10111 30.3396 2.35192 28.5683L0.74154 34.0632C2.54434 35.8194 4.58061 36.7479 6.65356 36.7588H6.92475C8.7549 36.7036 10.2329 35.808 11.4127 34.1757C11.4809 34.0852 11.5413 33.9904 11.6042 33.8933L11.0747 36.2867H15.8082L16.6038 32.1352C17.5022 32.6468 18.4435 32.9024 19.3901 32.8919C20.3129 32.8996 21.2307 32.6577 22.1096 32.1749L22.8808 36.2867H30.6101V27.6838H32.295C36.3705 27.6838 38.7803 24.1213 38.7803 18.1544C38.7803 11.5124 36.4386 8.46171 31.4532 8.46171ZM19.3953 26.6911C18.8253 26.697 18.2593 26.5267 17.7245 26.1882L19.3785 17.2345H19.4068L21.0326 26.2146C20.5064 26.5307 19.9528 26.6918 19.3953 26.6911ZM31.7591 21.5448H30.6101V14.3183H31.7591C33.2924 14.3183 34.5146 15.2007 34.5146 17.8786C34.5146 20.658 33.2924 21.5338 31.7591 21.5338",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_305_19692",
    x1: 26.5,
    y1: 0,
    x2: 26.5,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#01B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#0D90D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#1775C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#1C65BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E5FBB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_19692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 45,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSapIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sapIcon.0377cf4e.svg";
export { ForwardRef as ReactComponent };